var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.22664 4.81096C5.83611 4.42044 5.20295 4.42044 4.81242 4.81096C4.4219 5.20149 4.4219 5.83465 4.81242 6.22518L10.5871 11.9999L4.81248 17.7746C4.42196 18.1651 4.42196 18.7983 4.81248 19.1888C5.20301 19.5793 5.83617 19.5793 6.22669 19.1888L12.0013 13.4141L17.776 19.1888C18.1665 19.5793 18.7997 19.5793 19.1902 19.1888C19.5807 18.7983 19.5807 18.1651 19.1902 17.7746L13.4155 11.9999L19.1903 6.22518C19.5808 5.83465 19.5808 5.20149 19.1903 4.81096C18.7998 4.42044 18.1666 4.42044 17.7761 4.81096L12.0013 10.5857L6.22664 4.81096Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.d454414bc7c974bf5a5d963564b425c3.svg";
export { ForwardRef as ReactComponent };